<template>
  <Upload
    ref="upload"
    v-model="fileList"
    class="border-bottom-1px"
    :process-file="processFile"
    :max="max"
    :action="cAction"
    :accept="accept"
    :multiple="multiple"
    @files-added="handleFileAdded"
    @file-click="handleFileClick"
    @file-submitted="handleFileSubmitted"
    @file-success="handleFileSuccess"
    @file-removed="handleFileRemoved"
    @file-error="handleFileError"
  />
</template>
<script>
import storage from 'didi-store'
import { prefixUrl } from '@/common/utils/request'
import { trackEvent } from '@/common/utils/log'
import { get, cloneDeep } from 'lodash-es'
import { Upload } from '@didi/rich-ui'
import { isEmpty } from '@/common/utils/util'
import compress from '@/common/utils/image'
import * as env from '@/common/utils/env'
import { IsMobileBased } from '@/common/utils/env'
import { isAbasteceBiz } from '@/common/utils/BizUtils'
const MAX_FILESIZE = 10
const COMPRESS_FILESIZE = 0.1
window.SODA_UPLOAD_FILES = {}

export default {
  name: 'UploadWrapper',
  props: {
    textContent: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      default: '',
    },
    errorAdaptor: {
      type: Function,
      default(error) {
        return error?.message || ''
      },
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    titleDesc: {
      type: String,
      required: false,
      default: '',
    },
    accept: {
      type: String,
      required: false,
      default: 'image/jpeg, image/jpg, image/png',
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    max: {
      type: Number,
      required: false,
      default: 10,
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    target: {
      type: String,
      required: false,
      default: prefixUrl('common.uploadPublicPic'),
    },
    simultaneousUploads: {
      // 并发上传个数
      type: Number,
      required: false,
      default: 3,
    },
    compressOption: {
      type: Object,
      required: false,
      default: () => ({
        type: 'file',
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.5,
        },
        noCompress: false,
      }),
    },
    // 限制上传文件大小
    size: {
      type: Number,
      required: false,
      default: MAX_FILESIZE * 1024 * 1024,
    },
    beforeUpload: {
      type: Function,
      required: false,
      default: file => file,
    },
  },
  // eslint-disable-next-line vue/order-in-components
  components: {
    Upload,
  },
  data() {
    const ticket = this.$store.state.login.ticket
    const self = this
    return {
      fileList: [],
      cValues: [],
      action: {
        accept: this.accept,
        target: prefixUrl('common.uploadPublicPic'),
        fileName: 'upfile',
        data: {
          ticket,
        },
        checkSuccess(res, file) {
          if (res.errno === 0 && res.data) {
            return true
          } else if (res.data && res.data.redirectUrl) {
            self
              .$createToast({
                type: 'warn',
                time: 1000,
                txt: res.errmsg,
              })
              .show()
            /* eslint-disable */
            setTimeout(() => {
              location.href = res.data.redirectUrl
            }, 1000)
          } else {
            let fileKey = get(file, 'file.fileKey', '')
            if (fileKey) {
              const now = new Date().getTime()
              trackEvent('sailing_gattarman_x_api_image_upload_error', {
                name: file.name,
                originalSize: window.SODA_UPLOAD_FILES[fileKey].originalSize,
                compressedSize: file.size,
                diff: now - window.SODA_UPLOAD_FILES[fileKey].start,
                traceId: res.traceId,
              })
              delete window.SODA_UPLOAD_FILES[fileKey]
            }
            setTimeout(() => {
              self
                .$createToast({
                  type: 'warn',
                  time: 1000,
                  txt: self.gettext('上传失败，请重新上传'),
                })
                .show()
            }, 0)
            return false
          }
        },
      },
    }
  },
  computed: {
    cAction() {
      return this.$attrs.action ? this.$attrs.action : this.action
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          let pics = null
          if (isAbasteceBiz()) {
            pics = storage.get('visitFormValue')?.photos
          } else {
            pics = get(storage.get('visitFormValue'), [this.path || 'shopPics'], [])
          }
          if (storage.get('tipsVisitingCrash') && pics && pics.length && IsMobileBased()) {
            this.loadImages(pics)
          } else {
            this.loadImages(JSON.parse(JSON.stringify(newVal)))
          }
        }
      },
    },
  },
  methods: {
    loadImages(images) {
      images.forEach((item, index) => {
        let response = { data: {} }
        if (env.isHttps) {
          response.data.urlHttps = item
        } else {
          response.data.url = item
        }
        this.fileList.push({
          name: `initImage${index}.jpeg`,
          size: 100,
          url: item,
          status: 'success',
          progress: 1,
          response,
        })
      })
      console.log({
        fileList: this.fileList,
        images,
      })
      this.cValues = images
    },
    handleFileClick(data) {
      this.$attrs.onClick?.(data)
    },
    filesAddedHandler(
      maxSize = MAX_FILESIZE * 1024 * 1024,
      currentLength,
      maxLength,
      item,
      target,
    ) {
      let self = this
      return function (files) {
        files = Array.from(files)
        let hasIgnore = false

        if (files && files.length + currentLength > maxLength) {
          files.splice(maxLength)
        }
        for (let file of files) {
          // 唯一标志
          file.fileKey = `${file.name}${new Date().getTime()}`
          file.hasCompressed = file.size < COMPRESS_FILESIZE * 1024 * 1024
          if (file.size > maxSize) {
            file.ignore = true
            hasIgnore = true
          }
          window.SODA_UPLOAD_FILES[file.fileKey] = {
            start: new Date().getTime(),
            originalSize: file.size,
          }
        }
        hasIgnore &&
          self
            .$createToast({
              type: 'warn',
              time: 1000,
              txt: sprintf(self.gettext('上传照片不能超过%dMB，请重新上传'), MAX_FILESIZE),
            })
            .show()
        if (!!get(item, 'customCropper.flag', false)) {
          self
            .$createFullCutPicture({
              file: files[0],
              item: item,
              target: target,
            })
            .show()
        }
      }
    },
    handleFileAdded(files) {
      let self = this
      let maxSize = MAX_FILESIZE * 1024 * 1024
      files = Array.from(files)
      let hasIgnore = false
      for (let file of files) {
        // 唯一标志
        file.fileKey = `${file.name}${new Date().getTime()}`
        file.hasCompressed = file.size < COMPRESS_FILESIZE * 1024 * 1024
        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
        }
        window.SODA_UPLOAD_FILES[file.fileKey] = {
          start: new Date().getTime(),
          originalSize: file.size,
        }
      }
      hasIgnore &&
        self
          .$createToast({
            type: 'warn',
            time: 1000,
            txt: sprintf(self.gettext('上传照片不能超过%dMB，请重新上传'), MAX_FILESIZE),
          })
          .show()
    },
    handleFileSuccess(data) {
      const response = data.response
      if (response.errno !== undefined && response.errno === 0) {
        // 只有后端返回errno = 0  才代表成功
        const result = response.data
        const tarUrl = env.isHttps ? result.urlHttps : result.url
        this.cValues.push(tarUrl)
        console.log(this.cValues, 'handleFileSuccess.cvalue[log]')
        this.$emit('input', this.cValues)
        this.$emit('change', cloneDeep(this.cValues))
      }
    },
    handleFileRemoved(data) {
      console.log(data, 'data[handleFileRemoved]')
      if (
        !isEmpty(data.response) &&
        !isEmpty(data.response.data) &&
        !isEmpty(data.response.data.url || data.response.data.urlHttps)
      ) {
        const removed = env.isHttps ? data.response.data.urlHttps : data.response.data.url
        console.log(removed, 'removed[log]')
        console.log(this.cValues, 'this.cValues[log]')
        const filterResult = this.cValues.filter(item => {
          return item !== removed
        })
        this.cValues = filterResult
        this.$emit('input', filterResult)
        this.$emit('change', cloneDeep(this.cValues))
      }
    },
    handleFileSubmitted(data) {
      // ; (this.$attrs.onChange)?.(data)
      // console.log('[log] data =>', data)
      // this.$emit('input', data)
      // this.$emit('change', data)
    },
    handleFileError(data) {
      this.$attrs.onError?.(error, file, fileList)
      setTimeout(() => {
        // 出错情况: 超时 网络中断 登录过期[只有登陆过去才有response]
        if (isEmpty(data) || isEmpty(data.response)) {
          return
        }
        if (data.response.errno !== 0) {
          const response = data.response
          // 登录过期情况
          if (!isEmpty(response.data) && response.data.redirectUrl) {
            this.toastText = response.errmsg
            this.$refs.toast && this.$refs.toast.show()
            this.$nextTick(() => {
              location.href = response.data.redirectUrl
            }, 7000)
          }
          this.$refs.upload.$emit('file-error')
        }
      }, 0)
    },
    async processFile(file, next) {
      if (file.size > this.size) {
        let errTips = `文件大小不可超过${parseInt(this.size / 1000000)}MB`
        console.error(errTips)
        this.toastText = errTips
        this.$refs.toast && this.$refs.toast.show()
        this.$refs.upload.files.pop()
        return false
      }

      // 先执行 beforeUpload 钩子，获取可能被裁剪后的文件
      const processedFile = await this.beforeUpload(file)
      if (!processedFile) {
        this.$refs.upload.files.pop()
        return false
      }

      if (this.compressOption.noCompress) {
        next(processedFile)
      } else {
        compress(processedFile, this.compressOption, next)
      }
    },
    change() {},
  },
}
</script>
